import React, { type Dispatch, type SetStateAction, useCallback } from "react";
import { StyleSheet } from "react-native";

import { useBrowser } from "@stepapp/core";
import {
  Block,
  BottomSheet,
  Button,
  SvgIcon,
  Touchable,
  Typography,
  palette,
  spacing,
} from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { useAppLinks } from "../../hooks";

type Props = {
  isVisible: boolean;
  setModalVisible: Dispatch<SetStateAction<boolean>>;
};

const LocationDisclaimerSheet = ({ isVisible, setModalVisible }: Props) => {
  const { t } = useTranslation();
  const { ProposeCity } = useAppLinks();
  const openProposeCity = useBrowser(ProposeCity);

  const navigateToProposeCity = useCallback(() => {
    setModalVisible(false);
    setTimeout(openProposeCity, 1000);
  }, [setModalVisible, openProposeCity]);

  return (
    <BottomSheet
      contentStyle={styles.container}
      toggle={() => setModalVisible(false)}
      visible={isVisible}
    >
      <Block alignStart padding={1}>
        <Touchable onPress={() => setModalVisible(false)}>
          <Block alignCenter justifyCenter style={styles.closeIcon}>
            <SvgIcon color={palette.secondary.grey} name="cross" size={36} />
          </Block>
        </Touchable>
      </Block>

      <Block paddingBottom={3} paddingHorizontal={4}>
        <Block alignCenter justifyCenter paddingBottom={6}>
          <SvgIcon name="localization" />

          <Block paddingVertical={4}>
            <Typography center type="white" variant="newH1">
              {t("screens.notAvailableLocation.notAvailableLocationTtile")}
            </Typography>
          </Block>
          <Typography center type="white" variant="body">
            {t("screens.notAvailableLocation.notAvailableLocationDescription")}
          </Typography>
        </Block>
        <Button
          label={t("screens.notAvailableLocation.proposeCity")}
          onPress={navigateToProposeCity}
          type="secondary"
        />
      </Block>
    </BottomSheet>
  );
};

export default React.memo(LocationDisclaimerSheet);

const styles = StyleSheet.create({
  closeIcon: {
    backgroundColor: palette.common.black,
    borderRadius: 20,
    borderTopStartRadius: 20,
    marginBottom: spacing.unit * 2.5,
  },
  container: {
    backgroundColor: palette.primary.accent,
    padding: spacing.unit * 2.5,
  },
});
